
import Eye from "../../../assets/outline/Eye.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function EyeIcon({ className, dataTestid = "EyeIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Eye data-testid={dataTestid} className={classes} {...rest} />
  );
}
